module.exports = __webpack_public_path__ + "img/icon_menu_home.7aa140ae.svg";